module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 9-e3e128d3a7dc156f149f093a6b17e7bf.jpg";